export default "__VITE_ASSET__KUvciKsq__"